// import React, { useState, useEffect, useRef } from "react";
// import { Card, CardBody, CardTitle, CardSubtitle, Row } from "reactstrap";
// import { Star, Activity, Loader } from "react-feather";
// import { IApplicationState } from "../../../redux/reducers";
// import { connect } from "react-redux";
// import dashboardService from "../../../services/dashboardService";
// import { IDashboardState } from "../../../redux/reducers/dashboardReducer";
// import { IProductAnalyticsData } from "../../../interfaces/dashboard";
// import AccountNotifications from "../../newDashboard/components/accountNotifications";
// import Upgrade from "../../../components/common/upgrade";
// import { DataSet } from "../../../components/charts/interfaces";
// import LineChart from "../../../components/charts/lineChart";

// interface IProps {
// 	handleStarredContent: () => void;
// 	getOverview: () => Promise<any>;
// 	getDashboardProductAnalytics: () => Promise<any>;
// 	dashboard: IDashboardState;
// 	profile: any;
// }

// const IngredientOverview: React.FC<IProps> = ({
// 	dashboard: {
// 		active_products_count,
// 		concept_products_count,
// 		star_ingredients_count,
// 		company_info,
// 		product_analytics
// 	},
// 	profile,
// 	handleStarredContent,
// 	getOverview,
// 	getDashboardProductAnalytics
// }) => {
// 	const [loading, setLoading] = useState<boolean>(false);

// 	useEffect(() => {
// 		setLoading(true);
// 		Promise.all([getOverview(), getDashboardProductAnalytics()]).finally(() => {
// 			setLoading(false);
// 		});
// 	}, []);

// 	const reduceProductData = (label: string, type: string) => {
// 		let dataset: DataSet = {
// 			label: label,
// 			data: [],
// 			fill: false,
// 			backgroundColor: "",
// 			borderColor: "#fff"
// 		};
// 		product_analytics?.forEach((d: IProductAnalyticsData) => {
// 			dataset.data = [...dataset.data, d.retail_ingredients];
// 		});
// 		return dataset;
// 	};

// 	return (
// 		<div className="ingredient-overview mt-n3">
// 			<Row className="mb-2">
// 				<div className="mt-3 mr-2">
// 					<AccountNotifications mini filterBy={"ingredient"} />
// 				</div>
// 				<div className="mr-2 mt-3">
// 					<Card className="product mb-0">
// 						<CardBody>
// 							<div>
// 								<CardTitle>
// 									<h1 className="font-weight-semibold mb-0">
// 										<>
// 											{product_analytics
// 												? product_analytics.length != 0
// 													? product_analytics[product_analytics.length - 1].retail_ingredients
// 													: 0
// 												: 0}
// 										</>
// 									</h1>
// 									{loading ? <Loader className="fa-spin ml-2" /> : <Activity className="ml-2" />}
// 								</CardTitle>
// 								<CardSubtitle>
// 									Active Product <br /> Ingredients
// 								</CardSubtitle>
// 							</div>
// 							<div
// 								className={"ml-2 mt-4 mb-2"}
// 								// style={{ height: 165, maxHeight: 165, width: "100%" }}
// 							>
// 								<LineChart
// 									data={{
// 										labels: (product_analytics || []).map(
// 											(d: IProductAnalyticsData, index: number) => {
// 												return (index + 1).toString();
// 											}
// 										),
// 										datasets: [reduceProductData("Retail Ingredients", "ingredients")]
// 									}}
// 									noGridLines
// 									color={"#fff"}
// 									xLabel="Last 7 Days"
// 									// yStepSize={10}
// 								/>
// 							</div>
// 						</CardBody>
// 					</Card>
// 				</div>
// 				<div className="mr-2 mt-3">
// 					<Card className="starred mr-1 mb-0" onClick={handleStarredContent}>
// 						<CardBody>
// 							<div>
// 								<CardTitle>
// 									<h1 className="font-weight-semibold mb-0">{star_ingredients_count}</h1>
// 									{loading ? <Loader className="fa-spin ml-2" /> : <Star className="ml-2" />}
// 								</CardTitle>
// 								<CardSubtitle>
// 									Starred <br /> Ingredients
// 								</CardSubtitle>
// 							</div>
// 						</CardBody>
// 					</Card>
// 				</div>
// 			</Row>
// 		</div>
// 	);
// };

// const mapStateToProps = (state: IApplicationState) => {
// 	return {
// 		dashboard: state.dashboard,
// 		profile: state.user.profile
// 	};
// };

// const mapDispatchToProps = {
// 	getOverview: () => dashboardService.getDashboardOverview(),
// 	getDashboardProductAnalytics: () => dashboardService.getDashboardProductAnalytics()
// };
// export default connect(mapStateToProps, mapDispatchToProps)(IngredientOverview);

//working latest code
// import React, { useEffect, useState } from "react";
// import { Card, CardBody, CardTitle, CardSubtitle, Row } from "reactstrap";
// import { Star, Activity, Loader } from "react-feather";
// import { IApplicationState } from "../../../redux/reducers";
// import { connect } from "react-redux";
// import dashboardService from "../../../services/dashboardService";
// import { IDashboardState } from "../../../redux/reducers/dashboardReducer";
// import { IProductAnalyticsData } from "../../../interfaces/dashboard";
// import AccountNotifications from "../../newDashboard/components/accountNotifications";
// import LineChart from "../../../components/charts/lineChart";

// interface IProps {
//   handleStarredContent: () => void;
//   getOverview: () => Promise<any>;
//   getDashboardProductAnalytics: () => Promise<any>;
//   dashboard: IDashboardState;
//   profile: any;
// }

// const IngredientOverview: React.FC<IProps> = ({
//   dashboard: {
//     star_ingredients_count,
//     product_analytics
//   },
//   handleStarredContent,
//   getOverview,
//   getDashboardProductAnalytics
// }) => {
//   const [loading, setLoading] = useState<boolean>(false);

//   useEffect(() => {
//     setLoading(true);
//     Promise.all([getOverview(), getDashboardProductAnalytics()]).finally(() => {
//       setLoading(false);
//     });
//   }, [getOverview, getDashboardProductAnalytics]);

//   const reduceProductData = (label: string) => {
//     let dataset = {
//       label,
//       data: [] as number[],
//       fill: false,
//       backgroundColor: "",
//       borderColor: "#fff"
//     };
//     product_analytics?.forEach((d: IProductAnalyticsData) => {
//       dataset.data = [...dataset.data, d.retail_ingredients];
//     });
//     return dataset;
//   };

//   return (
//     <div className="ingredient-overview mt-n3">
//       <div className="scroll-container">
//         <Row className="mb-2">
//           <div className="mt-3 mr-2">
//             <AccountNotifications mini filterBy={"ingredient"} />
//           </div>
//           <div className="mr-2 mt-3">
//             <Card className="product mb-0">
//               <CardBody>
//                 <div>
//                   <CardTitle>
//                     <h1 className="font-weight-semibold mb-0">
//                       {product_analytics?.length ? product_analytics[product_analytics.length - 1].retail_ingredients : 0}
//                     </h1>
//                     {loading ? <Loader className="fa-spin ml-2" /> : <Activity className="ml-2" />}
//                   </CardTitle>
//                   <CardSubtitle>
//                     Active Product <br /> Ingredients
//                   </CardSubtitle>
//                 </div>
//                 <div className="ml-2 mt-4 mb-2 line-chart-wrapper">
//                   <LineChart
//                     data={{
//                       labels: (product_analytics || []).map((_, idx) => (idx + 1).toString()),
//                       datasets: [reduceProductData("Retail Ingredients")]
//                     }}
//                     noGridLines
//                     color="#fff"
//                     xLabel="Last 7 Days"
//                   />
//                 </div>
//               </CardBody>
//             </Card>
//           </div>
//           <div className="mr-2 mt-3">
//             <Card className="starred mr-1 mb-0" onClick={handleStarredContent}>
//               <CardBody>
//                 <div>
//                   <CardTitle>
//                     <h1 className="font-weight-semibold mb-0">{star_ingredients_count}</h1>
//                     {loading ? <Loader className="fa-spin ml-2" /> : <Star className="ml-2" />}
//                   </CardTitle>
//                   <CardSubtitle>
//                     Starred <br /> Ingredients
//                   </CardSubtitle>
//                 </div>
//               </CardBody>
//             </Card>
//           </div>
//         </Row>
//       </div>
//     </div>
//   );
// };

// const mapStateToProps = (state: IApplicationState) => ({
//   dashboard: state.dashboard,
//   profile: state.user.profile
// });

// const mapDispatchToProps = {
//   getOverview: () => dashboardService.getDashboardOverview(),
//   getDashboardProductAnalytics: () => dashboardService.getDashboardProductAnalytics()
// };

// export default connect(mapStateToProps, mapDispatchToProps)(IngredientOverview);


import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle, CardSubtitle, Row } from "reactstrap";
import { Star, Loader } from "react-feather";
import { IApplicationState } from "../../../redux/reducers";
import { connect } from "react-redux";
import dashboardService from "../../../services/dashboardService";
import { IDashboardState } from "../../../redux/reducers/dashboardReducer";
import { IProductAnalyticsData } from "../../../interfaces/dashboard";
import ProductStatCard from "../../products/components/ProductStatCard";
import IngredientActionsCard from "./IngredientActionsCard";

interface IProps {
	handleStarredContent: () => void;
	getOverview: () => Promise<any>;
	getDashboardProductAnalytics: () => Promise<any>;
	dashboard: IDashboardState;
	profile: any;
	notifications: any[];
}

const IngredientOverview: React.FC<IProps> = ({
	dashboard: {
		star_ingredients_count,
		product_analytics
	},
	handleStarredContent,
	getOverview,
	getDashboardProductAnalytics,
	notifications
}) => {
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		setLoading(true);
		Promise.all([getOverview(), getDashboardProductAnalytics()])
			.catch((error) => {
				console.error("Error loading ingredient overview data:", error);
			})
			.finally(() => {
				setLoading(false);
			});
	}, [getOverview, getDashboardProductAnalytics]);

	// Filter notifications for products (using the same filter as the original code)
	const ingredientNotifications = notifications?.filter(n => !n.read_at && n.data?.type === "ingredient") || [];
	const notificationsCount = ingredientNotifications.length;
	const totalActions = 10; // Placeholder or can be dynamic
	const actionsPendingCount = 0; // Placeholder

	const calculateTrend = (data: number[]) => {
		if (data.length < 2) return 0;
		const latest = data[data.length - 1];
		const earlier = data[data.length - 2];
		if (earlier === 0) return latest > 0 ? 100 : 0;
		return Math.round(((latest - earlier) / earlier) * 100);
	};

	const chartData = (product_analytics || []).map((d: IProductAnalyticsData) => d.retail_ingredients || 0);

	// Ensure we have at least 7 data points for a good looking sparkline
	const filledChartData = chartData.length > 0 ? chartData : [0, 0, 0, 0, 0, 0, 0];

	let percentageChange = 0;
	if (filledChartData.length > 1) {
		const current = filledChartData[filledChartData.length - 1];
		const previous = filledChartData[filledChartData.length - 2];
		if (previous > 0) {
			percentageChange = Math.round(((current - previous) / previous) * 100);
		} else if (current > 0) {
			percentageChange = 100;
		}
	}

	return (
		<div className="product-overview mt-n3 ingredient-overview">
			<Row className="mb-2 justify-content-center">
				{/* Ingredient Actions Card */}
				<div className="col-11 col-md-4 mb-3">
					<IngredientActionsCard
						notificationsCount={notificationsCount}
						totalActions={totalActions}
						actionsPendingCount={actionsPendingCount}
					/>
				</div>

				{/* Active Product Ingredients Card */}
				<div className="col-11 col-md-5 mb-3">
					<ProductStatCard
						title="Active Product Ingredients"
						count={chartData[chartData.length - 1] || 0}
						comparisonText="Across all products"
						percentageChange={percentageChange}
						data={filledChartData}
						type="active"
						loading={loading}
					/>
				</div>

				{/* Starred Ingredients Card - More compact */}
				<div className="col-11 col-md-3 mb-3">
					<Card
						className="starred-card border-0 shadow-sm h-100"
						onClick={handleStarredContent}
						style={{ backgroundColor: "#F9B850", color: "#fff", borderRadius: "20px", cursor: "pointer" }}
					>
						<CardBody className="p-4 d-flex flex-column align-items-center justify-content-center text-center">
							<div className="icon-bg mb-3" style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", padding: "10px", borderRadius: "10px" }}>
								<Star size={24} fill="#fff" />
							</div>
							<span className="font-weight-bold small text-uppercase mb-2" style={{ opacity: 0.9, letterSpacing: "0.5px" }}>
								Starred Ingredients
							</span>
							<h1 className="display-4 font-weight-bold mb-2" style={{ fontSize: "3rem" }}>
								{loading ? <Loader className="fa-spin" size={24} /> : (star_ingredients_count || 0)}
							</h1>
							<div className="mt-2">
								<span className="small" style={{ opacity: 0.8 }}>Saved to your profile</span>
							</div>
						</CardBody>
					</Card>
				</div>
			</Row>
		</div>
	);
};

const mapStateToProps = (state: IApplicationState) => {
	return {
		dashboard: state.dashboard,
		profile: state.user.profile,
		notifications: state.notification.all
	};
};

const mapDispatchToProps = {
	getOverview: () => dashboardService.getDashboardOverview(),
	getDashboardProductAnalytics: () => dashboardService.getDashboardProductAnalytics()
};

export default connect(mapStateToProps, mapDispatchToProps)(IngredientOverview);